import React, { useEffect, useState, useMemo } from "react";
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import { useLocation, useParams } from "react-router-dom";
import PreviewViewport from "../components/PreviewViewport";
import ThirdPersonPreviewViewport from "../components/ThirdPersonPreviewViewport";
import { useObjectStore } from "../zustand/objects";
import { useAccountStore } from "../zustand/account";

import SwitchToPreviewButton from "../components/SwitchToPreviewButton";
import { AddCommentButton } from "../components/AddCommentButton";
import SwitchVRMode from "../components/SwitchVRMode";
import StoryboardLinkButton from "../components/StoryboardLinkButton";
import ChangePreviewArtboard from "../components/ChangePreviewArtboard";
import { useGLTF } from '@react-three/drei'
import { getModelURLs, postRealtimeToken } from '../api.js';
import * as THREE from "three";
import debounce from 'lodash.debounce';

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const PreviewPage = ({ match }) => {

  let query = useQuery();

  const queryString = query.get("artboard")

  const { removePresence, realtimeToken, setRealtimeToken, currentObjectArtboard, presence, uniqueRealtimeId, addOrUpdatePresence, joinChannel, xanoClient, realtimeEventUpdate, updateArtboard, getSpecificUserProject, unloadObjects, loadObjects, previewVR, objectsAreLoaded, floorColour, artboards, getAIModels } = useObjectStore();
const {updateFirstName} = useAccountStore()

  const { projectKey } = useParams();


  async function unloadProject() {
    unloadObjects()

  }

  const [modelURLs, setModelURLs] = useState()



  useEffect(() => {
    unloadProject().then(() =>
      getSpecificUserProject(projectKey)).then(() =>
        getAIModels())
      .then(result => loadObjects())
      .then(res =>
        queryString ? updateArtboard(queryString) : updateArtboard('1'))
    // .then(() => prepareModelURLs())

  }, []);

  // XANO REALTIME SECTION
  const [realtime, setRealtime] = useState(false)

  const setRealtimeTokenFunction = (token) => {
    setRealtimeToken(token)
  }

  const processTokenResponse = (res) => {
    updateFirstName(res.firstName)
    setRealtimeTokenFunction(res.id)
    
  }
  
    const handleJoinToken = () => {
      postRealtimeToken().then(res => processTokenResponse(res))
    }

  const joinFunction = (action) => {
    setRealtime(true)
    handleJoinToken()
  }

  try {
    // declare channel
    const projectChannel = xanoClient.channel(`project/${projectKey}`, {
      presence: true,
    });
    // check for connection
    projectChannel.on("connection_status", (action) => {
      if (action.payload.status === "connected") {
        joinFunction(action)
      }
    }) 

    // react to someone joining/leaving
    projectChannel.on("presence_update", (action) => {
      const members = projectChannel.getPresence()
      action.payload.action === "join" && addOrUpdatePresence(action.payload.presence.socketId, 'editor', action)
      action.payload.action === "leave" && removePresence(action.payload.presence.socketId)
    })

    // listen for messages
    realtime && projectChannel.on("message", (action) => {

      // getting realtimeToken here so it's always the freshest one and not undefined
      const realtimeToken = useObjectStore.getState().realtimeToken;
      if (action.options.type === "projectUpdate") {
        if (realtimeToken !== action.payload.realtime_token) {
          debounce(realtimeEventUpdate(action), 100)
        }
      }
      else if (action.options.type === "presenceUpdate") {
        if (realtimeToken === action.payload.realtime_token && (action.payload.field === "preview")) {
          return
        }
        else {
          debounce(addOrUpdatePresence(action.client.socketId, action.payload.update[action.payload.field].page, action), 20)
        }
      }

    })

  } catch (err) {
    console.log("Error setting up Xano channel:", err); // Log channel setup errors
  }
  // END XANO REALTIME SECTION 

    const iconColour = { normal: '#606060ff', hover: '#868e96' }


  return previewVR ?
    <>
      {objectsAreLoaded && artboards && currentObjectArtboard && <PreviewViewport presence={presence} uniqueRealtimeId={uniqueRealtimeId} floorColour={floorColour} artboards={artboards} projectKey={projectKey} />}
      <Toolbar color="transparent" style={{ display: "flex", justifyContent: "end", background: 'transparent', boxShadow: 'none' }} >
        <Box>
          <Stack direction={"row"} spacing={1}>
            <Box style={{ backgroundColor: "white", borderRadius: 4, display: "flex" }} >
              <StoryboardLinkButton projectKey={projectKey} iconColour={iconColour}/>
              <SwitchVRMode />
              <SwitchToPreviewButton mode={"preview"} projectKey={projectKey} iconColour={iconColour} />
            </Box>
          </Stack>
        </Box>
      </Toolbar>

    </>
    :
    <>
      {objectsAreLoaded && artboards && currentObjectArtboard && <ThirdPersonPreviewViewport presence={presence} uniqueRealtimeId={uniqueRealtimeId} floorColour={floorColour} artboards={artboards} projectKey={projectKey} />}
      <Toolbar color="transparent" style={{ justifyContent: "end", background: 'transparent', boxShadow: 'none' }} >
        {/* <Box> */}
        <Stack direction={"row"} spacing={1}>
          <Box style={{ backgroundColor: "white", borderRadius: 4, display: "flex" }} >
            <StoryboardLinkButton projectKey={projectKey} iconColour={iconColour}/>
            <Divider orientation="vertical" variant="middle" flexItem style={{ height: "20px" }} />
            <SwitchVRMode />
            <Divider orientation="vertical" variant="middle" flexItem style={{ height: "20px" }} />
            <SwitchToPreviewButton mode={"preview"} projectKey={projectKey} iconColour={iconColour} />
            <Divider orientation="vertical" variant="middle" flexItem style={{ height: "20px" }} />
            <AddCommentButton />
            <Divider orientation="vertical" variant="middle" flexItem style={{ height: "20px" }}  />
            <ChangePreviewArtboard />
          </Box>
        </Stack>
        {/* </Box> */}
      </Toolbar>
    </>

};

export default PreviewPage;
